import { Dayjs } from 'dayjs';
import { IClaimReturnStatus } from './Claim';
import { IClaimStatus } from './Claims';

export interface IFilterState {
	collection: Collections;
	subcollection: SubCollections;
	size: number;
	search: boolean;
	searchCheckElegibility: string;
	buttonSearchCheckElegibility: boolean;
	inputCarrierClaimId: string;
	inputFiscalCode: string;
	inputMemberId: string;
	inputFirstName: string;
	inputLastName: string;
	inputDateOfBirth: Dayjs | null;
	dateOfService: Dayjs | null;
	isDateOfServiceValid: boolean;
	inputDateOfService: Dayjs | null;
	filterDateOfService: Dayjs | null;
	inputExternalClaimId: string;
	inputClaimFirstName: string;
	inputClaimLastName: string;
	inputClaimDate: string;
	inputClaimStatus: string;
	inputPaymentRunId: string | null;
	inputTotalAmount: number | null;
	sortingFields: string;
	sortingDirections: sortingDirections;
	claimsStatuses: IClaimStatus[];
	notificationStatuses: IClaimStatus[];
	claimReturnStatuses: IClaimReturnStatus[];
	fraudStatuses: IClaimReturnStatus[];
	complaintStatuses: IClaimReturnStatus[];
	complaintTypes: IClaimReturnStatus[];
	complaintOutcomes: IClaimReturnStatus[];
}

export interface IState {
	errorCode: number;
	errorMessage: string;
}

export interface IErrorInputResponse {
	errorCode: number;
	errorMessage: string;
}

export interface IFilterCheckEligibility
	extends IFilterState, IErrorInputResponse {}

export enum OptionsDatepicker {
	margin = 'margin',
	field = 'field',
}

export enum sortingDirections {
	DESC = 'DESC',
	ASC = 'ASC',
}

export enum Collections {
	NONE = 'none',
	CLAIMS = 'claims',
	PAYMENTS = 'payments',
}

export enum SubCollections {
	NONE = 'none',
	CLAIMS = 'claims',
	PAYMENTS = 'payments',
	NOTIFICATION = 'notification',
}

export const defaultSortingField = {
	[Collections.NONE]: '',
	[Collections.CLAIMS]: 'serviceDate,externalClaimId',
	[Collections.PAYMENTS]: 'paymentRunDate',
};
